// A dashboard left open during a deployment may request a retired Vite asset.
// Refresh once to fetch the current entry point, without creating a reload loop.
window.addEventListener('vite:preloadError', event => {
  if (!navigator.onLine) return;
  try {
    const key = 'heglo-asset-recovery';
    const now = Date.now();
    const previous = Number(sessionStorage.getItem(key) || 0);
    if (now - previous < 60_000) return;
    sessionStorage.setItem(key, String(now));
    event.preventDefault();
    window.location.reload();
  } catch {
    // If browser storage is unavailable, use the route's manual retry screen.
  }
});
